import { endpointZtl } from './base.config';

export const ztl = {
  createConsent: endpointZtl + `/consent/`,
  fetchConsentError: endpointZtl + `/consent/:consentId/errors`,
  scaSuccess: endpointZtl + `/consent/sca-successfully`,
  fetchConsentByCompany: endpointZtl + `/consent`,
  getOwnerConsents: endpointZtl + `/consent/:companyId/owner-consents`,

  // accounts
  fetchAccountsByConsent: endpointZtl + `/consent/:consentId/bank-accounts`,
  renewConsent: endpointZtl + `/consent/:consentId/renew`,
  getAllBankTemplate: endpointZtl + `/consent/:companyId/get-ztl-bank-template`,
  getZtlAccountList: endpointZtl + `/ztl-accounts/list`,
  getConsentHistory: endpointZtl + `/consent/:consentId/histories`,
  // onboarding
  baseOnboarding: endpointZtl + `/onboarding/:companyId`,
  // update status by flowId
  updateStatusByFlowId: endpointZtl + `/onboarding/:companyId/status`,
  onboardingStatistic: endpointZtl + `/statistics/onboarding`,
  consentStatistic: endpointZtl + `/statistics/consent`,
  // notification
  getZtlNotificationByCompany: endpointZtl + `/notifications/:companyId/list`,
  readZtlNotification: endpointZtl + `/notifications/update/:id/readed`,
  markZtlNotificationAsRead: endpointZtl + `/notifications/:companyId/read-all`,
  // payment 
  paymentValidate: endpointZtl + `/ztl-payments/validates`,
  getAvailableDueDates: endpointZtl + `/ztl-payments/available-due-dates/:initiatingCountry`,
  // supports
  getSupportedCurrencies: endpointZtl + `/ztl-supports/currencies`,
  getSupportedCountries: endpointZtl + `/ztl-supports/country`,
  getSupportedCurrencyByCountry: endpointZtl + `/ztl-supports/country/:countryCode/paymentrequirement`,
  supportedBankByCountry: endpointZtl + `/ztl-supports/banks/:countryCode/supported`,
};

export const ztlV2 = {
  cancelUnsignedInternational: endpointZtl + `/v2/payments/cancel-unsigned-international`,
  renewConsent: endpointZtl + `/v2/consents/:consentId/renew`,
  getConsent: endpointZtl + `/v2/consents/:consentId`,
  revokeConsent: endpointZtl + `/v2/consents`,
  createConsent: endpointZtl + `/v2/consents/`,
  scaSuccess: endpointZtl + `/v2/consents/sca-successfully`,
  supportedBankByCountry: endpointZtl + `/v2/banks/:countryCode/supported`,
  progressPdf: endpointZtl + `/v2/payments/:paymentId/progress-pdf`,
};

